import Upload from './_upload';

export default Upload;
